import notify from '@/utils/notify';
import rest from '@/plugins/rest';
import axios from 'axios';

let cancel;
const { CancelToken } = axios;
export default {
  async getMerchantsTypeCode(context, payload) {
    try {
      const { clientId, searchMerch } = payload;

      if (cancel !== undefined) {
        cancel();
      }

      let { data } = await rest.get(`/clients/${clientId}/merchant-code?searchMerch=${searchMerch}`,
        {
          cancelToken: new CancelToken(((c) => {
            cancel = c;
          })),
        });

      if (data.constructor.name === 'Array') {
        data = [];
      }

      return data;
    } catch (error) {
      if (axios.isCancel(error)) {
        return [];
      }

      notify.error('Error while searhing Merchant Items');

      const errorHandler = new ErrorEvent();
      errorHandler.sendError(error, 'Search Merchant Items');

      return Promise.resolve();
    }
  },

};
